window.TransformView = function () {
    var el = this;

    var SVG_TRANSFORM_ROTATE = 4;
    
    el.getRotate = function (element) {
        var pos = element.getBBox();
        var centerX = parseInt(pos.x + (pos.width / 2));
        var centerY = parseInt(pos.y + (pos.height / 2));
        var j;
        var angle = 0;
        var tfmList;
        var item = {};
        if (element.transform !== undefined) {
            tfmList = element.transform.baseVal;
            if (tfmList.numberOfItems > 0) {
                for (j = 0; j < tfmList.numberOfItems; j++) {
                    item = tfmList.getItem(j);
                    if (item.type === SVG_TRANSFORM_ROTATE) {
                        angle += item.angle;
                    }
                }
            }
        }

        return {angle: angle, x: centerX, y: centerY};
    };

    el.deleteRotate = function (element) {
        var j;
        var angle = 0;
        var tfmList;
        var item = {};
        if (element.transform !== undefined) {
            tfmList = element.transform.baseVal;
            if (tfmList.numberOfItems > 0) {
                for (j = 0; j < tfmList.numberOfItems; j++) {
                    item = tfmList.getItem(j);
                    if (item.type === SVG_TRANSFORM_ROTATE) {
                        angle += item.angle;
                        tfmList.removeItem(j);
                    }
                }
            }
        }

        return {
            angle: angle,
            tfmList: tfmList
        };
    };

    el.setRotate = function (element, angle, centerX, centerY) {
        if (element.transform !== undefined) {
            el.deleteRotate(element);
            var pos = element.getBBox();
            centerX = centerX || pos.x + pos.width / 2;
            centerY = centerY || pos.y + pos.height / 2;
            
            var rotate = element.ownerSVGElement.createSVGTransform();
            rotate.setRotate(angle, centerX, centerY);
            element.transform.baseVal.appendItem(rotate);
        }
    };

    el.addRotate = function (element, angle) {
        var transform = el.deleteRotate(element);
        el.setRotate(element, transform.angle + angle);
    };

    el.setOffsetPosition = function (element, x, y) {
        var pos = el.getPosition(element);

        var elTransform = el.deleteRotate(element);

        pos.x+= x;
        pos.y+= y;
        element.setAttribute('x', pos.x);
        element.setAttribute('y', pos.y);

        // set rotate of element
        if (elTransform.angle !== 0) {
            el.setRotate(element, elTransform.angle);
        }

        return pos;
    };
    
    el.setPosition = function (element, x, y) {
        var elTransform = el.deleteRotate(element);

        element.setAttribute('x', x);
        element.setAttribute('y', y);

        // set rotate of element
        if (elTransform.angle !== 0) {
            el.setRotate(element, elTransform.angle);
        }
    };
    
    el.getPosition = function(element) {
        return {
            x: parseInt(element.getAttribute('x')),
            y: parseInt(element.getAttribute('y')),
            width: parseInt(element.getAttribute('width')),
            height: parseInt(element.getAttribute('height'))
        };
    };
    
    el.getArea = function(element) {
        var pos = element.getBBox();
        var matrix = element.getCTM();
        var boxPos = {x1:0, y1:0, x2:0, y2:0};
        var Xx = [];
        var Yy = [];
        var countPoints = 4;
        var points = [];
        var i;

        for (i = 0; i < countPoints; i++) {
            points[i] = el.svgRoot.createSVGPoint();
        }
        
        points[0].x = pos.x;
        points[0].y = pos.y;
        points[1].x = pos.x + pos.width;
        points[1].y = pos.y;
        points[2].x = pos.x + pos.width;
        points[2].y = pos.y + pos.height;
        points[3].x = pos.x;
        points[3].y = pos.y + pos.height;
        
        for (i = 0; i < countPoints; i++) {
            points[i] = points[i].matrixTransform(matrix);
            Xx.push(parseInt(points[i].x));
            Yy.push(parseInt(points[i].y));
        }
        
        boxPos.x1 = Math.min.apply(Math, Xx);
        boxPos.x2 = Math.max.apply(Math, Xx);
        boxPos.y1 = Math.min.apply(Math, Yy);
        boxPos.y2 = Math.max.apply(Math, Yy);
        
        return boxPos;
    };
};